<template>
  <section class="initiatives">
    <div class="container">
      <div class="initiatives-inner">
        <div class="row">
          <div class="col-md-6 col-lg-5">
            <div class="column-img">
              <img class="particle1" src="@/assets/img/particle1.png" />
              <img class="main-img" src="@/assets/img/initiative1.png" alt="" />
            </div>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="initiatives-content">
              <h3>Learn from peers</h3>
              <p>
                Great CTOs learn from each other. Every CTO Circle member is
                invited to join a peer group - a group of 8-10 non-competing
                CTOs who connect once a month to overcome challenges together.
                We also offer mentor matching, local workshops, and a global CTO
                forum to help members grow.
              </p>
              <cs-button
                :to="{ name: 'InitiativeList' }"
                variant="primary"
                fill="solid"
                size="medium"
                :style="{
                  '--cs-button-color': '#ffffff',
                  '--cs-button-text-color': '#007ea3'
                }"
                >Learn More</cs-button
              >
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>

        <div class="row row-reverse">
          <div class="col-md-6 col-lg-5">
            <div class="column-img">
              <img class="particle2" src="@/assets/img/particle2.png" />
              <img class="main-img" src="@/assets/img/initiative2.png" alt="" />
            </div>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="initiatives-content">
              <h3>Build exceptional teams</h3>
              <p>
                Great teams are the secret to success. CTO Circle members are
                able to hire from our talent pool - a carefully vetted pool of
                high-performance freelancers and consultants - at no cost. Every
                member also gets a Talent Coach to help you develop a training /
                coaching program that takes your team from good to great. Open
                to a new role yourself? Find your next opportunity on our jobs
                board, with over 100 CTO roles added each month.
              </p>
              <cs-button
                :to="{ name: 'InitiativeList' }"
                variant="primary"
                fill="solid"
                size="medium"
                :style="{
                  '--cs-button-color': '#ffffff',
                  '--cs-button-text-color': '#007ea3'
                }"
                >Learn More</cs-button
              >
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-5">
            <div class="column-img">
              <img class="particle3" src="@/assets/img/particle3.png" />
              <img class="main-img" src="@/assets/img/initiative3.png" alt="" />
            </div>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="initiatives-content">
              <h3 class="reduce-cost-title">Reduce cost</h3>
              <p>
                CTO Circle members enjoy significant discounts on a wide range
                of tech essentials, including hardware, cloud services, and
                productivity software. Every member is also assigned a Cloud
                Efficiency Coach to help you maximise the ROI of your monthly
                cloud spend.
              </p>
              <cs-button
                :to="{ name: 'InitiativeList' }"
                variant="primary"
                fill="solid"
                size="medium"
                :style="{
                  '--cs-button-color': '#ffffff',
                  '--cs-button-text-color': '#007ea3'
                }"
                >Learn More</cs-button
              >
            </div>
          </div>
          <div class="col-lg-2"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.initiatives {
  padding: 180px 0;
  background: #007ea3;
  position: relative;
  overflow: hidden;
  .row-reverse {
    flex-direction: row-reverse;
  }
  &:before {
    content: '';
    background: #ffffff;
    width: 110%;
    height: 100px;
    position: absolute;
    top: 0;
    left: -5%;
    right: -5%;
    border-bottom-left-radius: 50% 100%;
    border-bottom-right-radius: 50% 100%;
  }
  &:after {
    content: '';
    background: #e7f0f2;
    width: 110%;
    height: 100px;
    position: absolute;
    bottom: 0;
    left: -5%;
    right: -5%;
    border-top-left-radius: 50% 100%;
    border-top-right-radius: 50% 100%;
  }

  h2 {
    text-align: center;
    color: #fff;
    margin-bottom: 60px;
  }

  .initiatives-inner .row {
    position: relative;
    margin-bottom: 60px;
  }
  .column-img {
    padding: 0 50px;
  }
  .column-img img {
    max-width: 100%;
    position: relative;
  }

  .initiatives-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
  }

  .initiatives-content h3 {
    color: #fff;
    margin-bottom: 10px;
  }

  .reduce-cost-title {
    margin-top: 30px;
  }

  .initiatives-content p {
    color: #f5f7f6;
    line-height: 30px;
    margin-bottom: 30px;
  }

  .initiatives-inner .row img.particle1 {
    position: absolute;
    left: -70px;
    top: 40px;
  }

  .initiatives-inner .row img.particle2 {
    position: absolute;
    right: -70px;
    top: -80px;
  }

  .initiatives-inner .row img.particle3 {
    position: absolute;
    left: -70px;
    top: -50px;
  }
}
</style>
